import { lazy } from 'react';

// project imports
import MainLayout from '../NewLayout/MainLayout';
import Loadable from '../ui-component/Loadable';
import PermissionRoute from './PermissionRoute';

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('../views/dashboard/Default')));

// inmuebles routing
const InmueblesDisponibles = Loadable(lazy(() => import('../views/catalogos/inmuebles/inmuebles-disponibles')));
const EdosCuentaContratos = Loadable(lazy(() => import('../views/inmuebles/edos-cuenta-contratos')));
const LegacyInvoiceOpen = Loadable(lazy(() => import('../views/invoices/LegacyInvoiceOpen')));

// buro routing
const CintaBuroPM = Loadable(lazy(() => import('../views/buro/CintaPM')));
const CintaBuroPF = Loadable(lazy(() => import('../views/buro/CintaPF')));

// contratos routing
const ContratoWizard = Loadable(lazy(() => import('../views/contratos')));
const Apartados = Loadable(lazy(() => import('../views/contratos/Apartados')));

// admin routing
const HistoriaManagement = Loadable(lazy(() => import('../views/admin/HistoriaManagement')));
const AdminManagement = Loadable(lazy(() => import('../views/admin/AdminManagement')));

// catalogos routing
const Inmuebles     = Loadable(lazy(() => import('../views/catalogos/inmuebles/inmuebles')));
const Inquilinos    = Loadable(lazy(() => import('../views/catalogos/inquilinos')));
const Fiadores      = Loadable(lazy(() => import('../views/catalogos/fiadores')));
const Directorio    = Loadable(lazy(() => import('../views/catalogos/directorio')));
const TiposInmueble = Loadable(lazy(() => import('../views/catalogos/inmuebles/tipo-de-inmueble')));
const TiposServicio = Loadable(lazy(() => import('../views/catalogos/tipos-de-servicio')));
const TipoDePersonal= Loadable(lazy(() => import ('../views/catalogos/tipo-de-personal')));
const Personal      = Loadable(lazy( () => import('../views/catalogos/personal')));
const TiposFormato  = Loadable(lazy( () => import('../views/catalogos/tipo-de-formato')));
const Duenios       = Loadable(lazy( () => import ('../views/catalogos/duenios')));
const Prioridad     = Loadable(lazy(() => import('../views/catalogos/prioridad')));
const TiposCargo    = Loadable(lazy(() => import('../views/catalogos/tipos-de-cargo')));
const TiposCobro    = Loadable(lazy( () => import('../views/catalogos/tipos-de-cobro')));
const Margen        = Loadable(lazy(() => import('../views/catalogos/margen')));
const Periodo       = Loadable(lazy(() => import('../views/catalogos/periodo')));
const Folios        = Loadable(lazy(() => import('../views/catalogos/folios-facturas')));
const MetodoPago    = Loadable(lazy(() => import('../views/catalogos/metodo-de-pago')));
const FoliosCBB     = Loadable(lazy(() => import('../views/catalogos/folios-cbb')));
const Asesores      = Loadable(lazy( () => import ('../views/asesores')));
const Apoderados    = Loadable(lazy( () => import ('../views/apoderados')));

// admin routing
const TiposContrato = Loadable(lazy(() => import('../views/administracion/tiposContrato')));
const RegimenFiscal = Loadable(lazy(() => import('../views/administracion/regimenFiscal')));
const UsoCFDI       = Loadable(lazy(() => import('../views/administracion/usoCFDI')));
const Usuarios      = Loadable(lazy(() => import('../views/administracion/usuarios')));
const ActividadUsuarios = Loadable(lazy(() => import('../views/administracion/actividad-usuarios')));
const Statistics = Loadable(lazy(() => import('../views/statistics')));

const protectedRoute = (permission, element) => (
    <PermissionRoute permission={permission}>{element}</PermissionRoute>
);
// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: <MainLayout />,
    children: [
        {
            path: '/',
            element: <DashboardDefault />
        },
        {
            path: 'dashboard',
            children: [
                {
                    path: 'default',
                    element: <DashboardDefault />
                }
            ]
        },
        {
            path: 'catalogos',
            children: [
                {
                    path: 'inmuebles',
                    element: protectedRoute('Inmuebles', <Inmuebles />)
                },
                {
                    path: 'inquilinos',
                    element: protectedRoute('Inquilinos', <Inquilinos />)
                },
                {
                    path: 'fiadores',
                    element: protectedRoute('Obligados Solidarios', <Fiadores/>)
                },
                {
                    path: 'directorio',
                    element: protectedRoute('Directorio', <Directorio/>)
                },
                {
                    path: 'tiposInmueble',
                    element: protectedRoute('Tipos de Inmueble', <TiposInmueble/>)
                },
                {
                    path: 'tiposServicio',
                    element: protectedRoute('Tipos de Servicio', <TiposServicio/>)
                },
                {
                    path: 'tiposPersonal',
                    element: protectedRoute('Tipos de Personal', <TipoDePersonal/>)
                },
                {
                    path: 'personal',
                    element: protectedRoute('Personal', <Personal/>)
                },
                {
                    path: 'tiposFormato',
                    element: protectedRoute('Tipos de Formato', <TiposFormato/>)
                },
                {
                    path: 'duenios',
                    element: protectedRoute('Dueños', <Duenios />)
                },
                {
                    path: 'prioridad',
                    element: protectedRoute('Prioridad', <Prioridad/>)
                },
                {
                    path: 'tiposCargo',
                    element: protectedRoute('Tipos de Cargo', <TiposCargo/>)
                },
                {
                    path: 'tiposCobro',
                    element: protectedRoute('Tipos de Cobro', <TiposCobro/>)
                },
                {
                    path: 'margen',
                    element: protectedRoute('Margen', <Margen/>)
                },
                {
                    path: 'periodo',
                    element: protectedRoute('Periodo', <Periodo/>)
                },
                {
                    path: 'folios',
                    element: protectedRoute('Folios', <Folios/>)
                },
                {
                    path: 'metodosPago',
                    element: protectedRoute('Métodos de Pago', <MetodoPago/>)
                },
                {
                    path: 'foliosCBB',
                    element: protectedRoute('Folios CBB', <FoliosCBB/>)
                },
                {
                    path: 'asesores',
                    element: protectedRoute('Asesores', <Asesores />)
                },
                {
                    path: 'apoderados',
                    element: protectedRoute('Apoderados', <Apoderados />)
                }
            ]
        },
        {
            path: 'inmuebles',
            children: [
                {
                    path: 'inmueblesDisponibles',
                    element: protectedRoute('Inmuebles Disponibles', <InmueblesDisponibles />)
                },
                {
                    path: 'edos-cuenta-contratos',
                    element: protectedRoute('Edos. Cta. Contratos', <EdosCuentaContratos />)
                }
            ]
        },
        {
            path: 'invoices',
            children: [
                {
                    path: 'legacy-open',
                    element: <LegacyInvoiceOpen />
                }
            ]
        },
        {
            path: 'contratos',
            children: [
                {
                    path: 'crear',
                    element: protectedRoute('Contrato Nuevo', <ContratoWizard />)
                },
                {
                    path: 'apartados',
                    element: protectedRoute('Apartado', <Apartados />)
                }
            ]
        },
        {
            path: 'buro',
            children: [
                {
                    path: 'buroPM',
                    element: protectedRoute('Cinta', <CintaBuroPM />)
                },
                {
                    path: 'buroPF',
                    element: protectedRoute('Cinta PF', <CintaBuroPF />)
                }
            ]
        },
        {
            path: 'administracion',
            children: [
                {
                    path: 'tiposContrato',
                    element: protectedRoute('Tipos de Contrato', <TiposContrato />)
                },
                {
                    path: 'regimenFiscal',
                    element: protectedRoute('Régimen Fiscal', <RegimenFiscal />)
                },
                {
                    path: 'usoCFDI',
                    element: protectedRoute('Uso de CFDI', <UsoCFDI />)
                },
                {
                    path: 'usuarios',
                    element: protectedRoute('Usuarios', <Usuarios />)
                },
                {
                    path: 'actividad-usuarios',
                    element: protectedRoute('Actividad de Usuarios', <ActividadUsuarios />)
                },
                {
                    path: 'gestion-historia',
                    element: protectedRoute('Gestión de Historia', <HistoriaManagement />)
                },
                {
                    path: 'gestion-admins',
                    element: protectedRoute('Gestión de Administradores', <AdminManagement />)
                }
            ]
        },
        {
            path: 'statistics',
            element: protectedRoute('Estadísticas', <Statistics />)
        },
    ]
};

export default MainRoutes;
